export function getSrcImg(
  srcImg: string,
  imgCacheDuration: number = 0,
): string {
  if (srcImg !== "") {
    return `https://cloud.squidex.io/api/assets/noracares/${srcImg}?cache=${imgCacheDuration}&download=0&quality=100`;
  }

  return "";
}
